/* jslint node: true */
/* jshint esversion: 6 */

import './Leads.scss';

import React from 'react';
import leadsModel from '../../../../model/leads';
import Loading from '../misc/Loading';

class LeadsTesting extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasResponse: false,
      responseObj: null,
      waitingForAjax: false,
      forms: null,
      serverIsProduction: null
    };

    this.submitDataText = '{"referer": "http%3A%2F%2Fwww.motorforum.no%2Fbestill-time%2F","dealerRef": "dealer_014","serviceTypes": ["testService"],"makeModel": "asdf","registrationNumber": "32432432","name": "asdf fdsafdsafasd\u00f8\u00f8","phone": "","email": "asdf@example.com","message": "melding \u00f8\u00e6 asdf"}';
    this.submitData = JSON.parse(this.submitDataText);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.fetchRules = this.fetchRules.bind(this);

    document.title = 'Admin - Leads testing';
  }

  UNSAFE_componentWillMount() { // eslint-disable-line camelcase
    this.fetchForms();
  }

  fetchForms() {
    leadsModel.getStatus().then((info) => {
      this.setState({
        forms: info.forms,
        serverIsProduction: info.server.production
      });
    }).catch((error) => {
      console.error(error);
    });
  }

  fetchRules(e) {
    e.preventDefault();

    const self = this;
    const formType = this.refSelect.value;

    this.setState({
      hasResponse: false,
      responseObj: {},
      waitingForAjax: true
    });

    leadsModel.getRules(formType).then(function (rules) {
      self.setState({
        hasResponse: true,
        responseObj: rules,
        waitingForAjax: false
      });
    }).catch(function () {
      self.setState({
        hasResponse: true,
        responseObj: 'Failed to fetch rules',
        waitingForAjax: false
      });
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    const jsonText = this.refJson.value;
    const formType = this.refSelect.value;
    let data;

    try {
      data = JSON.parse(jsonText);
    } catch (e) {
      console.error(e);
      data = false;
    }

    if (!data) {
      console.error('Invalid JSON');
      this.setState({
        hasResponse: true,
        responseObj: {error: 'Invalid JSON'},
        waitingForAjax: false
      });

      return false;
    }

    this.setState({
      hasResponse: false,
      responseObj: {},
      waitingForAjax: true
    });

    data.formType = formType;

    leadsModel.save(data).then((response) => {
      this.setState({
        hasResponse: true,
        responseObj: response,
        waitingForAjax: false
      });
    }).catch((result) => {
      if (result.status === 400) {
        result.json().then((response) => {
          if (response && response.error === 'Invalid data') {
            if (response.data && response.data.length) {
              this.setState({
                hasResponse: true,
                responseObj: {error: 'Invalid data', data: response.data},
                waitingForAjax: false
              });

              return;
            }
          }
        });
      }
    });
  }

  printServerStatus(prod) {
    if (prod) {
      return <span className="text-danger">PROD</span>;
    }

    return <span className="text-success">TEST</span>;
  }

  render() {
    const buttonStatusClass = this.state.waitingForAjax ? 'disabled' : '';
    const responseStatusClass = this.state.hasResponse ? 'show' : 'hide';

    if (!this.state.forms) {
      return (
        <Loading title="Leads" text="Laster status"/>
      );
    }

    return (
      <section>
        <div className="row">
          <div className="col-lg-12">
            <h2>Lead testing <small>(Server: {this.printServerStatus(this.state.serverIsProduction)})</small></h2>
            <form onSubmit={this.handleSubmit}>
              <div className="form-group">
                <label>Type</label>
                <select name="form" ref={(ref) => (this.refSelect = ref)} className="form-control">
                  {this.state.forms.map((form, i) => {
                    return <option key={i} value={form} defaultValue>{form}</option>;
                  })}
                </select>
              </div>
              <div className="form-group">
                <button onClick={this.fetchRules} className="btn btn-info">Vis regler</button>
              </div>
              <div className={`form-group ${responseStatusClass}`}>
                <label>Svar</label>
                <textarea rows="15" className="form-control" readOnly value={JSON.stringify(this.state.responseObj, null, 4)}></textarea>
              </div>
              <div className="form-group">
                <label>Eksempel data</label>
                <textarea ref={(ref) => (this.refJson = ref)} rows="16" name="test" className="form-control">{JSON.stringify(this.submitData, null, 4)}</textarea>
              </div>

              <div className="form-group">
                <input type="submit" className={`btn btn-success ${buttonStatusClass}`} name="submit" defaultValue="Send inn"/>
              </div>
            </form>
          </div>
        </div>
      </section>
    );
  }
}

export default LeadsTesting;
